<div class="checkout-product-container">
    <div *ngFor="let savedProduct of savedProducts$ | async; trackBy: trackByFn" class="checkout-card-container">
        <div class="primary-info">
            <a [routerLink]="savedProduct.mhpId ? (savedProduct.product?.sourcePrebuiltPackId ? [PACK_ROUTE, savedProduct.product.sourcePrebuiltPackId] : [MHP_BUILD_ROUTE]) : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(savedProduct.product.usanaId)]"
               [queryParams]="savedProduct.mhpId && !savedProduct.product?.sourcePrebuiltPackId ? {type: 'edit', packId: savedProduct.mhpId} : {}">
                <product-image imageType="productImage"
                               imageSize="XS" [images]="savedProduct.product.productImages" [imageAltText]="savedProduct.product.productDescription.name"></product-image>
            </a>
            <div class="product-details-container">
                <div class="flex-col">
                    <a class="heading-5"
                       [routerLink]="savedProduct.mhpId ? (savedProduct.product?.sourcePrebuiltPackId ? [PACK_ROUTE, savedProduct.product.sourcePrebuiltPackId] : [MHP_BUILD_ROUTE]) : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(savedProduct.product.usanaId)]"
                       [queryParams]="savedProduct.mhpId && !savedProduct.product?.sourcePrebuiltPackId ? {type: 'edit', packId: savedProduct.mhpId} : {}"
                       [innerHTML]="savedProduct.product.productDescription.name"></a>

                    <p class="product-price">
                        @if (showRetailPriceStrikethrough(savedProduct)) {
                            <span class="featured-retail-price retail-price margin-right-4">{{ savedProduct.product.retailPrice.price | usanacurrency | async }}</span>
                            <span class="product-actual-price">{{ savedProduct.product.price.price | usanacurrency | async }}</span>
                        } @else {
                            {{ savedProduct.product.price.price | usanacurrency | async }}
                        }
                    </p>
                    <p *ngIf="shouldDisplayVolume" class="product-volume">
                        {{'cart.product.recommended.volume' | translate}} {{savedProduct.product.price.volume}}
                    </p>
                    <fs-not-eligible [product]="savedProduct.product"></fs-not-eligible>
                </div>
            </div>
            <div class="summary-action-wrapper add-to-cart">
                <span class="summary-main-row">
                    @if (authenticated && !chinaCustomer) {
                        <a href="javascript:void(0)" (click)="productAddBackToCart(savedProduct)"
                           class="cart-product-summary-action float-end" translate="cart.product.addtocart"></a>
                    }
                </span>
                @if (showProductExclusiveTag(savedProduct)) {
                    <span class="product-exclusive-tag" [translate]="'cart.overview.product.exclusive.' + customerType"></span>
                }
            </div>
        </div>
        <i [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" (click)="deleteFromSaved(savedProduct)"></i>
    </div>
</div>
